export const DEFAULT_CHARACTER_NAME = "メイ";

export function getCharacterShortName(characterName?: string | null): string {
  if (!characterName) return DEFAULT_CHARACTER_NAME;

  const normalized = characterName
    .replace(/[「」『』]/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  if (!normalized) return DEFAULT_CHARACTER_NAME;

  const parts = normalized
    .split(/[ ・･._-]+/)
    .map((part) => part.trim())
    .filter(Boolean);

  return parts.length > 1 ? parts[parts.length - 1] : parts[0];
}
